// removed by extract-text-webpack-plugin
module.exports = {"qrLoginPage":"QRLogin__qrLoginPage","title":"QRLogin__title","endContainer":"QRLogin__endContainer","rememberMe":"QRLogin__rememberMe","logo":"QRLogin__logo","qrSignUpPage":"QRLogin__qrSignUpPage","growDotQello":"QRLogin__growDotQello","growDotBlue":"QRLogin__growDotBlue","growDotGolden":"QRLogin__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/QRLogin/QRLogin.scss
// module id = 1912
// module chunks = 0